import { ArrowRightOutlined, UserOutlined, CheckCircleFilled } from "@ant-design/icons";
import { Avatar, Popover, Progress, Tag } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { getTargetString } from "../../helpers/targetHelpers";
import moment from "moment";

function TopPlanCard(props) {
  function goToUser() {}

  return (
    <div className="max-w-5xl mb-6">
      <div
        className="border rounded"
        style={{
          borderColor: "#e5e7eb",
        }}
      >
        <div className="flex">
          <div className="w-full p-6">
            <div className="flex justify-between w-full items-center">
              <div>
                <div className="flex items-center mb-1">
                  <Tag>{props.plan?.planGroup}</Tag>
                  <div className="text-xs text-gray-400">
                    {props.plan?.targetDate
                      ? moment(props.plan?.targetDate).format("DD.MM.YYYY")
                      : ""}
                  </div>
                </div>
                <div className="flex items-center">
                  {props.plan?.title}
                  {(props.plan?.finalized === 1 || props.plan?.finalized === "1" || props.plan?.finalized === true) && (
                    <CheckCircleFilled 
                      style={{ 
                        color: '#90EE90', 
                        marginLeft: '8px', 
                        fontSize: '16px' 
                      }} 
                      title="Plan Finalized"
                    />
                  )}
                  {" - "}
                  {getTargetString(
                    props.plan?.target,
                    props.plan?.scale?.scaleName,
                    props.plan?.scale?.scaleUnitAbbreviation
                  )}
                </div>
              </div>
              <div onClick={() => goToUser()} className="">
                <Popover
                  placement="left"
                  content={
                    <div>
                      {props.plan?.assignedTo?.firstName +
                        " " +
                        props.plan?.assignedTo?.lastName}
                    </div>
                  }
                  trigger="hover"
                >
                  {props.plan?.assignedTo?.imageUrl ? (
                    <Avatar
                      className="cursor-pointer"
                      src={props.plan?.assignedTo?.imageUrl}
                    />
                  ) : (
                    <Avatar>
                      {props.plan?.assignedTo?.firstName
                        ?.charAt(0)
                        .toUpperCase()}
                    </Avatar>
                  )}
                </Popover>
              </div>
            </div>
            <Progress
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
              percent={props.plan?.performance || 0}
            />
          </div>
          <Link to={`/top-plans/${props.plan?.planId}`}>
            <div className="flex justify-center items-center p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer h-full">
              <ArrowRightOutlined />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TopPlanCard;
